<div class="custom-price-container ">
    <span class="bold offer-price-part font-26">{{ offer | offerMainPrice:selectedPremium | separator}}{{mainTailsSeparator}}</span>
    <span class="bold offer-price-part font-20">{{ offer | offerTailsPrice:selectedPremium}}</span>
    <span class="bold offer-price-part font-20">&nbsp;{{'OFFER_SECTION.SHARED.currencyShortcut' | translate}}</span>

    <div *ngIf="showInstalment" class="discount-price">
        {{'OFFER_SECTION.BOX.installmentFrom' | translate}}
        <span class="discount-price--bold"> {{offer | lowestFirstInstalment }} {{'OFFER_SECTION.SHARED.currencyShortcut' | translate}}</span>
    </div>
</div>
